import icon from '@devsisters/ui-common/lib/icon';
import styled from '@emotion/styled';
import React, { MouseEventHandler } from 'react';

import { css, scale } from '~/css';

interface ArrowButtonProps {
  onClick?: MouseEventHandler;
}

const PrevIcon = styled(
  icon(
    '0 0 49 49',
    <g>
      <path
        className='bg'
        d='M24.500,-0.000 C38.031,-0.000 49.000,10.969 49.000,24.500 C49.000,38.031 38.031,49.000 24.500,49.000 C10.969,49.000 0.000,38.031 0.000,24.500 C0.000,10.969 10.969,-0.000 24.500,-0.000 Z'
      />
      <path
        fill='rgb(255, 255, 255)'
        d='M29.632,15.111 L19.743,25.000 L29.632,34.889 C30.803,36.061 30.803,37.960 29.632,39.132 C28.460,40.303 26.561,40.303 25.389,39.132 L13.483,27.225 C13.446,27.192 13.404,27.167 13.368,27.132 C12.780,26.543 12.488,25.771 12.491,25.000 C12.488,24.229 12.780,23.457 13.368,22.868 C13.403,22.833 13.445,22.809 13.481,22.776 L25.389,10.868 C26.561,9.697 28.460,9.697 29.632,10.868 C30.803,12.040 30.803,13.939 29.632,15.111 Z'
      />
    </g>,
  ),
)(
  css({
    fontSize: [scale(49), 49],
    pointerEvents: 'none',
    '.bg': {
      fill: ['rgba(0, 0, 0, 0.525)', 'rgba(0, 0, 0, 0.525)', 'rgba(0, 0, 0, 0.3)'],
    },
  }),
);

const NextIcon = styled(PrevIcon)(
  css({
    transform: 'scaleX(-1)',
    pointerEvents: 'none',
  }),
);

const ArrowButton = styled('button')((props: { position: 'left' | 'right'; onClick?: MouseEventHandler }) =>
  css({
    display: 'inline-flex',
    alignItems: 'center',
    border: 'none',
    outline: 'none',
    background: 'none',
    position: 'absolute',
    zIndex: 1,
    top: '50%',
    left: {
      left: 15,
      right: 'calc(100% - 15px)',
    }[props.position],
    transform: {
      left: ['translate(-50%, -50%)', 'translate(-50%, -50%)', 'translateX(-100%) translate(-50%, -50%)'],
      right: ['translate(-50%, -50%)', 'translate(-50%, -50%)', 'translateX(100%) translate(-50%, -50%)'],
    }[props.position],
    cursor: 'pointer',
    opacity: 0.5,
    ...(props.onClick && {
      ':hover, :focus': {
        opacity: 1,
      },
    }),
  })(props),
);

const Prev: React.FC<ArrowButtonProps> = ({ onClick }) => (
  <ArrowButton onClick={onClick} position='left' className='carousel-arrow-button'>
    <PrevIcon />
  </ArrowButton>
);

Prev.displayName = 'ArrowButton.Prev';

const Next: React.FC<ArrowButtonProps> = ({ onClick }) => (
  <ArrowButton onClick={onClick} position='right' className='carousel-arrow-button'>
    <NextIcon />
  </ArrowButton>
);

Next.displayName = 'ArrowButton.Next';

export { Next, Prev };
